import { useTranslation } from 'react-i18next'

import { ArrowsClockwiseIcon, CoinsIcon, DotsThreeCircleIcon } from '@phosphor-icons/react'

import { Button, ButtonMenu, Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const MoreActionsMenu = ({
  allowsEditReturnLabels,
  onChangeDeliveryMethod,
  isChangeDeliveryMethodDisabled,
  onEditTransactionResult,
  editTransactionResultLabel,
}) => {
  const { t } = useTranslation()
  return (
    <ButtonMenu
      menuItems={[
        {
          label: (
            <Styles.MenuItemLabelContainer>
              <ArrowsClockwiseIcon size={16} />
              <Text type="bodyMRegular">{t('Cambiar método de devolución')}</Text>
            </Styles.MenuItemLabelContainer>
          ),
          disabled: !allowsEditReturnLabels,
          onClick: onChangeDeliveryMethod,
          visible: !isChangeDeliveryMethodDisabled,
        },
        {
          label: (
            <Styles.MenuItemLabelContainer>
              <CoinsIcon size={16} />
              <Text type="bodyMRegular">{editTransactionResultLabel}</Text>
            </Styles.MenuItemLabelContainer>
          ),
          onClick: onEditTransactionResult,
          visible: !!onEditTransactionResult,
        },
      ]}
      renderButton={onClick => (
        <Button variant="text" onClick={onClick} size="s">
          <DotsThreeCircleIcon size={16} />
          {t('Más acciones')}
        </Button>
      )}
    />
  )
}

export default MoreActionsMenu
